import React from 'react';
import parse from 'html-react-parser';

const AlertMessageBox = ({ type = 'info', text }) => {
  let webconnectIcon = '';
  switch (type) {
    case 'warning':
      webconnectIcon = 'webconnect-exclamation-circle-fill';
      break;
    case 'success':
      webconnectIcon = 'webconnect-check-circle';
      break;
    case 'danger':
      webconnectIcon = 'webconnect-x-circle-fill';
      break;
    default:
      webconnectIcon = 'webconnect-info-circle';
      break;
  }
  if (text) {
    return (
      <div className="row">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
          <div className={`alert alert-${type}`}>
            <div className="alert-icon">
              <i className={`wb ${webconnectIcon}`} style={{ verticalAlign: '1px' }}></i>
            </div>
            {parse(text) || ''}
          </div>
        </div>
      </div>
    );
  } else {
    return '';
  }
};

export default AlertMessageBox;
